export let globalHeaderRef: React.RefObject<HTMLDivElement>;

export function setGlobalHeaderRef(ref: React.RefObject<HTMLDivElement>) {
    globalHeaderRef = ref;
}